import SearchClientRepository from "@domain/repositories/SearchClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { ChartDataResponse } from "@domain/models/ChartDataResponse";
import { Filter } from "@domain/models/Filters";
import { userRoles } from "@domain/models/User";

type Input = {
  filters: Filter[];
  monthsInterval: { month: number; year: number; startTime: number; endTime: number }[];
};

type Output = Promise<ChartDataResponse[]>;

export class GetChartClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly searchClientRepository: SearchClientRepository
  ) {}

  async execute({ filters, monthsInterval }: Input) {
    const array: ChartDataResponse[] = [];

    for (const interval of monthsInterval) {
      let textFilters = ``;
      const facetFilters = [];

      const user = this.userStore.user;

      if (user.role === userRoles.manager) {
        let stringFilter = "(";

        for (const index in user.operatorsIds) {
          const operator = user.users.operators.find((x) => x.id === user.operatorsIds[index]);

          if (operator) {
            if (parseInt(index) === 0) {
              stringFilter = stringFilter + `operatorName:"${operator.name}"`;
            } else {
              stringFilter = stringFilter + " OR " + `operatorName:"${operator.name}"`;
            }
          }
        }
        stringFilter = stringFilter + ")";

        textFilters = textFilters + stringFilter;
      }

      let stringFilter = textFilters.length > 0 ? " AND " : "";

      stringFilter =
        stringFilter + `(lastReportDate:${interval.startTime} TO ${interval.endTime})` + "";

      textFilters = textFilters + stringFilter;

      for (const filter of filters) {
        if (filter.type !== "date") {
          if (filter.values?.length > 0) {
            let stringFilter = textFilters.length > 0 ? " AND (" : "(";

            for (const index in filter.values) {
              if (parseInt(index) === 0) {
                stringFilter = stringFilter + `${filter.field}:"${filter.values[index].value}"`;
              } else {
                stringFilter =
                  stringFilter + " OR " + `${filter.field}:"${filter.values[index].value}"`;
              }
            }
            stringFilter = stringFilter + ")";

            textFilters = textFilters + stringFilter;
          }
        }
      }

      const response = await this.searchClientRepository.searchClients(
        "",
        textFilters,
        facetFilters,
        1,
        1
      );

      const clients = response.total;

      array.push({
        month: interval.month,
        year: interval.year,
        value: clients,
      });
    }

    return array;
  }
}
